import { Children } from 'react';
import { render, createPortal } from 'react-dom';
const idPortal = 'DGN-UI-Portal',
      classNameCommon = 'DGN-UI-Portal';
export const getPortal = () => {
  const portal = document.getElementById(idPortal);
  if (portal) return portal;
  const node = document.createElement('div');
  node.id = idPortal;
  node.style.cssText = 'position: fixed; inset: 0; pointer-events: none; z-index: 9000;';
  return document.body.appendChild(node);
};
export const isLastChildNode = node => {
  if (!node) return false;

  if (typeof node === 'string') {
    node = document.querySelector(node);
  } else {
    node = node.current || node.target || node;
  }

  const portal = getPortal();
  const length = portal.childNodes.length;
  return length && portal.lastChild.contains(node);
};
export const renderPortal = (node, containers, isCreate = false, options = {}) => {
  const {
    style = {},
    className
  } = options;
  let container = getPortal();
  Object.assign(container, style);

  if (className) {
    container.classList.add(className);
  }

  if (containers) {
    containers.classList.add(classNameCommon);
    containers.style.pointerEvents = 'auto';
    container = container.appendChild(containers);

    if (isCreate) {
      return /*#__PURE__*/createPortal(node, container);
    } else {
      render(node, container);
    }
  } else {
    Children.forEach(node, containerChild => {
      const parent = document.createElement(containerChild.type);
      const children = containerChild.props.children;
      Object.keys(containerChild.props).forEach(key => {
        if (!/__EMOTION_TYPE_PLEASE_DO_NOT_USE__|children/.test(key)) {
          if (key === 'css') {
            parent.classList.add(`css-${containerChild.props[key].name}`);
          } else if (key === 'style') {
            Object.assign(parent.style, containerChild.props[key]);
          } else {
            parent[key] = containerChild.props[key];
          }
        }
      });
      parent.classList.add(classNameCommon);
      parent.style.pointerEvents = 'auto';
      container = container.appendChild(parent);

      if (isCreate) {
        return /*#__PURE__*/createPortal(children, container);
      } else {
        render(children, container);
      }
    });
  }
};
export const removePortal = node => {
  if (isLastChildNode(node)) {
    node.remove();
    removePortalCommon();
    return true;
  }

  return false;
};
export const removePortalCommon = () => {
  const portals = getPortal();

  if (!portals.childNodes.length) {
    portals.remove();
  }
};